import { useState, useEffect } from 'react';
import { DEVICE_TYPE, DEVICE_CONSTANTS } from '../data/Constants';

const getDimensions = () => {
  return {
    height: typeof window.innerHeight !== 'undefined' ? window.innerHeight : 0,
    width: typeof window.innerWidth !== 'undefined' ? window.innerWidth : 0,
  };
};

const getHeightType = (windowDimensions) => {
  const { MOBILE, DESKTOP } = DEVICE_TYPE;
  const { height } = windowDimensions;
  const { MOBILE_HEIGHT } = DEVICE_CONSTANTS;

  let deviceHeightType = DESKTOP;
  let IS_MOBILE_HEIGHT = false;

  if (typeof windowDimensions === 'undefined') {
    return {
      deviceHeightType,
      IS_MOBILE_HEIGHT,
    };
  } else if (height <= MOBILE_HEIGHT) {
    deviceHeightType = MOBILE;
    IS_MOBILE_HEIGHT = true;
  }

  return {
    deviceHeightType,
    IS_MOBILE_HEIGHT,
  };
};

export default function WindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getDimensions());
  const [deviceHeightType, setDeviceHeightType] = useState(
    getHeightType(windowDimensions),
  );

  useEffect(() => {
    const updateDimensions = () => {
      const dimensions = getDimensions();
      setWindowDimensions(dimensions);
      setDeviceHeightType(getHeightType(dimensions));
    };

    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  });

  return {
    ...windowDimensions,
    ...deviceHeightType,
  };
}
